import { render, staticRenderFns } from "./AscParameterAlert.vue?vue&type=template&id=4af70d92&"
import script from "./AscParameterAlert.vue?vue&type=script&lang=js&"
export * from "./AscParameterAlert.vue?vue&type=script&lang=js&"
import style0 from "./AscParameterAlert.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports